import { NavigateFunction } from 'react-router-dom';
import { FormInstance, message } from 'antd';

import { initProductSuccessAction, IProductStore } from 'containers/Products/Product/store';

import { getDateForPayload, getFormChanges } from 'utils';

import { Links } from 'links';

import { EffectivePeriod, ProductCreate, ProductDetails, ProductUpdate } from 'codegen';
import { IDataResponse, RecursiveRequired, TRequestCallback } from 'types';

export const handleSuccessPatchProductDetails = (
  { data }: IDataResponse<ProductDetails>,
) => {
  initProductSuccessAction(data);
  message.success('Product successfully updated!');
};

export const handleSuccessPostProductDetails = (
  navigate: NavigateFunction,
) => (
  { data }: IDataResponse<ProductDetails>,
) => {
  navigate(`${Links.Products}/${data.id}`);
};

export const handleProductDetailsPatchRequest = (
  form: FormInstance<RecursiveRequired<IProductStore['initialValues']>>,
  initialValues: IProductStore['initialValues'],
  patchProductDetails: TRequestCallback<ProductUpdate>,
) => () => {
  const changes = getFormChanges(initialValues, form);

  const effectivePeriods = changes.effectivePeriods?.map(({ id, effectiveFrom, effectiveTo }) => ({
    id,
    effectiveFrom: getDateForPayload(effectiveFrom),
    effectiveTo: getDateForPayload(effectiveTo),
  })) as EffectivePeriod[];

  patchProductDetails({
    payload: {
      ...changes,
      ...(effectivePeriods && { effectivePeriods }),
    },
  });
};

export const handleProductDetailsPostRequest = (
  form: FormInstance<RecursiveRequired<IProductStore['initialValues']>>,
  postProductDetails: TRequestCallback<ProductCreate>,
) => () => {
  const values = form.getFieldsValue();

  const effectivePeriods = values.effectivePeriods.map(({ effectiveFrom, effectiveTo }) => ({
    effectiveFrom: getDateForPayload(effectiveFrom),
    effectiveTo: getDateForPayload(effectiveTo),
  }));

  postProductDetails({
    payload: {
      ...values,
      effectivePeriods,
    },
  });
};
